import { render, staticRenderFns } from "./SendAnnouncement.vue?vue&type=template&id=73756e0c&scoped=true"
import script from "./SendAnnouncement.vue?vue&type=script&lang=js"
export * from "./SendAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73756e0c",
  null
  
)

export default component.exports